/* Winks LP — Sticky CTA + Exit Modal */

(function(){
  var sticky = document.getElementById('lp-stickyCta');
  var hero = document.querySelector('.lp .hero');
  if (!sticky || !hero) return;
  function onScroll(){
    var trigger = hero.offsetTop + hero.offsetHeight - 100;
    var past = window.scrollY > trigger;
    var footer = document.querySelector('footer');
    var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight + 40 : false;
    sticky.classList.toggle('show', past && !nearFooter);
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();

(function(){
  var modal = document.getElementById('lp-exitModal');
  var close = document.getElementById('lp-exitClose');
  if (!modal || !close) return;
  var shown = sessionStorage.getItem('winksExitShown') === '1';
  function fire(){
    if (shown) return;
    shown = true;
    sessionStorage.setItem('winksExitShown', '1');
    modal.classList.add('show');
  }
  close.addEventListener('click', function(){ modal.classList.remove('show'); });
  modal.addEventListener('click', function(e){ if (e.target === modal) modal.classList.remove('show'); });
  document.addEventListener('mouseout', function(e){
    if (!e.toElement && !e.relatedTarget && e.clientY < 10) fire();
  });
  var engaged = false;
  setTimeout(function(){ engaged = true; }, 15000);
  var lastY = window.scrollY;
  window.addEventListener('scroll', function(){
    var y = window.scrollY;
    if (engaged && lastY - y > 120) fire();
    lastY = y;
  }, {passive:true});
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') modal.classList.remove('show'); });
})();
